// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__32ZGi","title":"AfterBackImages_title__2RPEf","images":"AfterBackImages_images__18DlK"};